import '../App.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Helmet } from "react-helmet-async";

function PhotoGallery() {
  return (
    <>
    <Helmet>
        <title> Photo Gallery of Harpwood House </title>
        <meta
          name="description"
          content="A photo gallery of Harpwood House, showcasing our residents, staff, and facilities."
        />
        <link rel="canonical" href="https://www.harpwood.house/photo-gallery"/>
      </Helmet>

    <div className="page">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Header />

      <main id="main-content">
        <section className="content-section photo-gallery-page">
          <div className="photo-gallery-container">
            <h1>Photo Gallery</h1>
          </div>
        </section>

        <section className="photo-gallery-grid">
          <div className="gallery-grid">
              <div className="gallery-item">
                <img src="/hero-image-2.jpg" alt="Harpwood House" />
              </div>
              <div className="gallery-item">
                <img src="/hero-image-3.jpg" alt="Harpwood House" />
              </div>
              <div className="gallery-item">
                <img src="/hero-image-4.jpg" alt="Harpwood House" />
              </div>
              <div className="gallery-item">
                <img src="/hero-image-5.jpg" alt="Harpwood House" />
              </div>
              <div className="gallery-item">
                <img src="/hero-image-6.jpg" alt="Harpwood House" />
              </div>
              <div className="gallery-item">
                <img src="/hero-image-7.jpg" alt="Harpwood House" />
              </div>
              <div className="gallery-item">
                <img src="/hero-image-8.jpg" alt="Harpwood House" />
              </div>
              <div className="gallery-item">
                <img src="/hero-image-9.jpg" alt="Harpwood House" />
              </div>
              <div className="gallery-item">
                <img src="/whitstable-suite-image.jpg" alt="Care Suite" />
              </div>
              <div className="gallery-item">
                <img src="/whitstable-suite-image-2.jpg" alt="Care Suite" />
              </div>
              <div className="gallery-item">
                <img src="/whitstable-suite-image-3.jpg" alt="Care Suite" />
              </div>
              <div className="gallery-item">
                <img src="/whitstable-suite-main-room.jpg" alt="Care Suite Main Room" />
              </div>
            </div>
        </section>
      </main>

      <Footer />
    </div>
    </>
  );
}

export default PhotoGallery;
